export enum RouteParamEnum {
    FINE_ID = ':fineId',
}
